import {Injector} from "@angular/core"
import {ReifiedMeshData} from "@cm/template-nodes"
import {Observable} from "rxjs"
import {MeshNodes, DataNodes} from "@cm/render-nodes"
import {hashObject} from "@cm/utils"
import {evaluateMesh, WebAssemblyWorkerService} from "@app/template-editor/helpers/mesh-processing"
import {BaseGeometryDataCache} from "@app/template-editor/helpers/base-geometry-data-cache"

export class MeshDataCache extends BaseGeometryDataCache<MeshNodes.Mesh, ReifiedMeshData> {
    constructor(injector: Injector) {
        const workerService = injector.get(WebAssemblyWorkerService)
        super((graph, resources) => evaluateMesh(workerService, graph, resources))
    }

    evaluateMesh(graph: MeshNodes.Mesh, resources: DataNodes.EvaluationResources): Observable<ReifiedMeshData> {
        return this.cache.get(hashObject(graph), [graph, resources])
    }
}
